import React, { Suspense } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Route, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import LoaderCircle from "../components/common/loader-circle";
import AdminLayout from "./../components/admin/layout";
import EnterpriseLayout from "./../components/enterprise/layout";

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  isMFAAuthenticated,
  isAdminAuthenticated,
  isMFAAdminAuthenticated,
  userPermissions,
  refreshing,
  routefor,
  layout,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (routefor == "admin") {
          if (!isAdminAuthenticated) {
            return (
              <Redirect
                to={{
                  pathname: "/admin/login",
                  state: { from: props.location },
                }}
              />
            );
          }
          if (isAdminAuthenticated && !isMFAAdminAuthenticated) {
            return (
              <Redirect
                to={{
                  pathname: "/admin/auth-check",
                  state: { from: props.location },
                }}
              />
            );
          }
          return (
            <Suspense fallback={<div>Loading...</div>}>
              <LoaderCircle isLoading={refreshing} />
              {isAdminAuthenticated ? (
                layout == "sidebar" ? (
                  <React.Fragment>
                    <AdminLayout>
                      <Component {...props} />
                    </AdminLayout>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Component {...props} />
                  </React.Fragment>
                )
              ) : (
                <Redirect
                  to={{
                    pathname: "/admin/login",
                    state: { from: props.location },
                  }}
                />
              )}
            </Suspense>
          );
        }
        const restProp = { ...rest };
        if (
          isAuthenticated &&
          isMFAAuthenticated &&
          restProp.permission !== undefined &&
          !_.isEmpty(userPermissions) &&
          !userPermissions.includes(restProp.permission)
        ) {
          return (
            <Redirect
              to={{
                pathname: "/enterprise/unauthorized",
                state: { from: props.location },
              }}
            />
          );
        }
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          );
        }
        if (isAuthenticated && !isMFAAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/auth-check",
                state: { from: props.location },
              }}
            />
          );
        }
        return (
          <Suspense fallback={<div>Loading...</div>}>
            <LoaderCircle isLoading={refreshing} />
            {isAuthenticated && isMFAAuthenticated ? (
              layout == "sidebar" ? (
                <React.Fragment>
                  <EnterpriseLayout>
                    <Component {...props} />
                  </EnterpriseLayout>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Component {...props} />
                </React.Fragment>
              )
            ) : (
              <></>
            )}
          </Suspense>
        );
      }}
    />
  );
};

PrivateRoute.displayName = "Private Routes";

PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
  location: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  isAdminAuthenticated: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

// Retrieve data from store as props
function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    isMFAAuthenticated: store.auth.isMFAAuthenticated,
    isAdminAuthenticated: store.auth.isAdminAuthenticated,
    isMFAAdminAuthenticated: store.auth.isMFAAdminAuthenticated,
    refreshing: store.generalActions.refreshing,
    userPermissions: store.auth.user.roleId.permissions,
  };
}

export default withRouter(connect(mapStateToProps)(PrivateRoute));
